import { AxiosError } from 'axios';
import { useI18n } from 'contexts/i18n';
import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { dsoCartService } from 'services';
import { AddDsoLineItemParams, DsoCartErrorResponse } from 'types';
import { displayNotification } from 'utils/notification';

export const useDsoAddLineItemsToCart = () => {
  const queryClient = useQueryClient();
  const i18n = useI18n();
  return useMutation(
    ServerStateKeysEnum.dsoAddLineitemMutation,
    (lineItems: AddDsoLineItemParams[]) => {
      return dsoCartService.addLineItemsToCart(lineItems);
    },
    {
      onSuccess: (data, variables, context) => {
        queryClient.setQueriesData([ServerStateKeysEnum.dsoCart], data);
      },
      onError: (err: AxiosError<DsoCartErrorResponse>) => {
        if (err.response?.status !== 422) {
          const data = err?.response?.data;
          const errMessage =
            (data && 'error' in data ? data.error : undefined) ??
            i18n['Failed to add to Cart!'];
          displayNotification(errMessage, 'danger');
        }
      },
    }
  );
};
